export default "__VITE_ASSET__DX44dOAp__"